import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "template", "container" ]

  connect() {
  }

  addField(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/TEMPLATE_ID/g, new Date().valueOf());
    this.containerTarget.insertAdjacentHTML('beforeend', content)

    // Notificar al controlador de exclusión de productos que se agregó un campo
    const exclusionController = this.application.getControllerForElementAndIdentifier(
      this.element,
      'menu-product-exclusion'
    )
    if (exclusionController) {
      exclusionController.fieldAdded()
    }
  }
}
